import { render, staticRenderFns } from "./CustomTestReportBuilder.vue?vue&type=template&id=4ca5c50a&scoped=true&"
import script from "./CustomTestReportBuilder.vue?vue&type=script&lang=js&"
export * from "./CustomTestReportBuilder.vue?vue&type=script&lang=js&"
import style0 from "./CustomTestReportBuilder.vue?vue&type=style&index=0&id=4ca5c50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5c50a",
  null
  
)

export default component.exports